import Api from '@/services/Api'

export default {
  // Sve sto kasa treba pri otvaranju: serversko vrijeme, radno vrijeme,
  // operater, oznake poslovnog prostora i sljedeci broj racuna.
  pocetak (query) {
    return Api().get('kasa/pocetak', {params: query})
  },
  // Novi racun. Broj, datum, vrijeme i iznose racuna posluzitelj.
  racun (racun) {
    return Api().post('kasa/racun', racun)
  },
  // Popis racuna. Zadano samo oni bez JIR-a; "sve" vraca i fiskalizirane.
  racuni (query) {
    return Api().get('kasa/racuni', {params: query})
  },
  // Racuni s kase iz vazecih ugovora. Uz "pregled: true" nista se ne sprema.
  izUgovora (tijelo) {
    return Api().post('kasa/izugovora', tijelo)
  },
  // Obracun kase za razdoblje: iznosi, stope PDV-a, nacini placanja.
  obracun (query) {
    return Api().get('kasa/obracun', {params: query})
  },
  // Podaci za pisac; sam ispis salje preglednik jer je pisac uz kasu.
  ispis (id, params) {
    return Api().get('kasa/racun/' + id + '/ispis', {params: params || {}})
  },
  // Brisanje. Fiskaliziran racun posluzitelj odbija; za racun koji nije zadnji
  // u nizu trazi izricitu potvrdu jer ostaje rupa u brojevima.
  obrisi (id, potvrdaRupe) {
    return Api().delete('kasa/racun/' + id, {data: {potvrdaRupe: potvrdaRupe === true}})
  },
  // Slanje na fiskalizaciju. Neuspjeh nije greska - racun ostaje bez JIR-a.
  // "odmah" je samo poziv neposredno iza naplate, dok kupac jos stoji za
  // pultom; sve ostalo Porezna prima kao naknadnu dostavu.
  fiskaliziraj (id, odmah) {
    return Api().post('kasa/racun/' + id + '/fiskaliziraj', {odmah: odmah === true})
  }
}
